module.exports = __webpack_public_path__ + "img/3DModel.e195d556.svg";